// Set up Baron tile product mapping
const baronTiles = {
  radar: {
    composite_250m: {
      code: 'C39-0x0361-0',
      zIndex: 250,
      interval: 5,
    },
    reflectivity_base: 'TLH-0x0426-1',
    velocity_base: 'TLH-0x0422-1',
    baron_button: 'TLH-0x0265-0'
  },
  satellite: {
    infrared: {
      code: 'C39-0×0304-0',
      zIndex: 250,
      interval: 30,
    },
    visible: {
      code: 'SA3-0×0301-0',
      zIndex: 250,
      interval: 30,
    }
  },
  baron3k: {
    precip24hr: {
      code: 'baron-hires-precipaccum-in-surface',
      zIndex: 250,
      interval: 30
    }
  },
  tropical: {
    nhc: {
      code: 'tropical-cone-forecast-us',
      zIndex: 250,
      interval: 30,
    },
    spaghetti: {
      code: 'tropical-spaghetti-plot-us',
      zIndex: 250,
      interval: 30,
    }
  },
  alerts: {
    county: {
      code: 'alert-all',
      zIndex: 300,
      interval: 15,
    },
    polygon: {
      code: 'alert-poly',
      zIndex: 300,
      interval: 5
    },
    county_polygon_combined: {
      code: 'alert-all-poly',
      zIndex: 300,
      interval: 15,
    },
    marine: {
      code: 'alert-marine',
      zIndex: 300,
      interval: 15,
    }
  },
}

export { baronTiles }